import { render, staticRenderFns } from "./antecedent-allergologie-familiaux.html?vue&type=template&id=029cfc89&scoped=true&external"
import script from "./antecedent-allergologie-familiaux.js?vue&type=script&lang=js&external"
export * from "./antecedent-allergologie-familiaux.js?vue&type=script&lang=js&external"
import style0 from "./antecedent-allergologie-familiaux.scss?vue&type=style&index=0&id=029cfc89&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029cfc89",
  null
  
)

export default component.exports